import { FC, ReactNode } from 'react';

type TReadOnlyWrapperProps = {
  children: ReactNode;
  isReadOnly: boolean;
};

/**
 * Wrapper component that provides visual feedback for read-only content
 *
 * The wrapper uses a two-layer approach:
 * - Outer div: Handles cursor and visual feedback (opacity, cursor)
 * - Inner div: Disables pointer events on actual content
 *
 * This allows the cursor to change and provides visual indication
 * while preventing interaction with the content.
 */
const ReadOnlyWrapper: FC<TReadOnlyWrapperProps> = ({
  children,
  isReadOnly,
}) => {
  if (!isReadOnly) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        position: 'relative',
        cursor: 'not-allowed',
        opacity: 0.7,
      }}
      title="You do not have permission to edit this section"
    >
      <div style={{ pointerEvents: 'none' }}>{children}</div>
    </div>
  );
};

export default ReadOnlyWrapper;
